import { useCallback, useState } from "react";

type UnsavedChangesChoice = "save" | "discard" | "cancel";

type UnsavedChangesRequest = {
  message: string;
  /** Offer Save as well as Discard. */
  canSave: boolean;
  resolve: (choice: UnsavedChangesChoice) => void;
};

export type UnsavedChangesDialogProps = {
  request: Omit<UnsavedChangesRequest, "resolve"> | null;
  onChoose: (choice: UnsavedChangesChoice) => void;
};

/** Ask-and-await state for `UnsavedChangesDialog`; `ask` resolves with the user's choice. */
export function useUnsavedChangesPrompt() {
  const [request, setRequest] = useState<UnsavedChangesRequest | null>(null);

  const ask = useCallback(
    (params: { message: string; canSave: boolean }) =>
      new Promise<UnsavedChangesChoice>((resolve) => setRequest({ ...params, resolve })),
    []
  );

  const onChoose = useCallback(
    (choice: UnsavedChangesChoice) => {
      request?.resolve(choice);
      setRequest(null);
    },
    [request]
  );

  const dialogProps: UnsavedChangesDialogProps = { request, onChoose };
  return { ask, dialogProps };
}
